export default "__VITE_ASSET__DCu0c0$Z__"